import React from "react";
import { useField } from "formik";

//  Styles
import "./Inputs.scss";

const InputFeedback = ({ error }) =>
    error ? <div className="form__error">{error}</div> : null;

const TextInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <>
            <div className="form__group field">
                <input className={`form__field`} {...field} {...props} />
                <label htmlFor={props.id || props.name} className="form__label">
                    {label}
                </label>
                {meta.touched && meta.error && (
                    <InputFeedback error={meta.error} />
                )}
            </div>
        </>
    );
};

const TextArea = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <>
            <div className="form__group field">
                <textarea {...field} {...props} className="form__field" />
                <label htmlFor={props.id || props.name} className="form__label">
                    {label}
                </label>

                {meta.touched && meta.error && (
                    <InputFeedback error={meta.error} />
                )}
            </div>
        </>
    );
};

const RadioButton = ({
    field: { name, value, onChange, onBlur },
    id,
    label,
    className,
    ...props
}) => {
    return (
        <>
            <input
                name={name}
                id={id}
                type="radio"
                value={id} // could be something else for output?
                checked={id === value}
                onChange={onChange}
                onBlur={onBlur}
                className="radio-field"
                {...props}
            />
            <label htmlFor={id} className="radio-labels">
                {label}
            </label>
        </>
    );
};

const RadioButtonGroup = ({
    value,
    error,
    touched,
    id,
    label,
    className,
    children,
}) => {
    return (
        <div
            className={`input-field ${className} ${
                value || (!error && touched && "is-success")
            } ${!!error && touched && "is-error"}`}
        >
            <fieldset>
                <legend>{label}</legend>
                {children}
                {touched && <InputFeedback error={error} />}
            </fieldset>
        </div>
    );
};

const FileInput = ({ label, ...props }) => {
    const [, meta] = useField(props);

    return (
        <div className="form__group field">
            <label htmlFor={props.id || props.name}>{label}</label>
            <br />
            <input {...props} />
            {meta.touched && meta.error && <InputFeedback error={meta.error} />}
        </div>
    );
};

export { TextArea, TextInput, RadioButton, RadioButtonGroup, InputFeedback, FileInput };
